import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { login } from "../../store/user/actions";
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  Alert,
} from "reactstrap";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.user.authenticated) this.props.history.push("/");
  }

  performLogin() {
    const { username, password } = this.state;
    this.props.login(username, password);
  }

  handleInputChange(e) {
    if (e.key === "Enter") {
      this.performLogin();
    }
  }

  render() {
    const { error, signingIn } = this.props.user;

    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="5">
              <CardGroup className="mb-4">
                <Card className="p-4">
                  <CardBody>
                    <h1>Iniciar Sesión</h1>
                    <p className="text-muted">Ingresa a tu cuenta</p>

                    {error && <Alert color="danger">{error}</Alert>}

                    <InputGroup className="mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="icon-user"></i>
                        </span>
                      </div>
                      <Input
                        type="text"
                        placeholder="Usuario"
                        onChange={(e) =>
                          this.setState({ username: e.target.value })
                        }
                        onKeyPress={this.handleInputChange}
                      />
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="icon-lock"></i>
                        </span>
                      </div>
                      <Input
                        type="password"
                        placeholder="Contraseña"
                        onChange={(e) =>
                          this.setState({ password: e.target.value })
                        }
                        onKeyPress={this.handleInputChange}
                      />
                    </InputGroup>
                    <Row>
                      <Col xs="4">
                        <Button
                          color="primary"
                          className="px-4"
                          disabled={signingIn}
                          onClick={() => this.performLogin()}
                        >
                          Ingresar
                        </Button>
                      </Col>
                      <Col xs="8" className="text-right">
                        <Button
                          color="link"
                          className="px-0"
                          onClick={() =>
                            this.props.history.push("/forgotpassword")
                          }
                        >
                          ¿Olvidaste tu contraseña?
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      login,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/scenes/Login/Login.js